var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("b-navbar", { attrs: { toggleable: "md" } }, [
    _c(
      "div",
      { staticClass: "mx-auto d-sm-flex d-block flex-sm-nowrap" },
      [
        _c("b-navbar-toggle", { attrs: { target: "nav_collapse_funeral" } }),
        _vm._v(" "),
        _c(
          "b-collapse",
          {
            staticClass: "text-center collapse navbar-collapse",
            attrs: { "is-nav": "", id: "nav_collapse_funeral" }
          },
          [
            _c(
              "b-navbar-nav",
              [
                _c("b-nav-item", { attrs: { to: "/my-funeral/burial" } }, [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.$t("menu.items.funeral.burial")) +
                      "\n                "
                  )
                ]),
                _vm._v(" "),
                _c("b-nav-item", { attrs: { to: "/my-funeral/ceremony" } }, [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.$t("menu.items.funeral.ceremony")) +
                      "\n                "
                  )
                ]),
                _vm._v(" "),
                _c("b-nav-item", { attrs: { to: "/my-funeral/guestlist" } }, [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.$t("menu.items.funeral.guestlist")) +
                      "\n                "
                  )
                ]),
                _vm._v(" "),
                _c("b-nav-item", { attrs: { to: "/my-funeral/speeches" } }, [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.$t("menu.items.funeral.speeches")) +
                      "\n                "
                  )
                ])
              ],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-83de77a2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-83de77a2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/funeral/FuneralMenuComponent.vue
// module id = null
// module chunks = 